import { atom } from "recoil";

import { ILanguageDto } from "../../dto";

export const languagesAtom = atom<ILanguageDto[]>({
  key: "languagesAtom",
  default: [],
});
